<template>
  <el-carousel autoplay arrow="always" loop>
    <el-carousel-item v-for="(item, index) in bannerList" :key="index">
      <div class="banner-swiper-div">
        <img :src="item.bannerUrl" class="banner-swiper-class" />
        <div v-if="item.lookDetails" class="banner-swiper-lookDetails" :class="{'banner-swiper-lookDetails-three': index === 3}">
          {{ item.lookDetails }}
        </div>
        <img
          :src="item.textUrl"
          class="banner-swiper-text"
          @click="openNewWork(item.toUrl)"
          :clstag="item.clstag"
        />
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "HomeBanner",

  data() {
    return {
      bannerList: [
        {
          bannerUrl: require("@/assets/img/banner-four.png"),
          textUrl: require("@/assets/img/banner-text-four.png"),
          toUrl: "",
        },
        {
          bannerUrl: require("@/assets/img/banner-five.png"),
          textUrl: require("@/assets/img/banner-text-five.png"),
          lookDetails: "查看详情",
          toUrl: "https://dingpan.jd.com",
          clstag: "DSGJ|clickPcBanner",
        },
        {
          bannerUrl: require("@/assets/img/banner-one.png"),
          textUrl: require("@/assets/img/banner-text-three.png"),
          lookDetails: "查看详情",
          toUrl: "https://finshop.jd.com/#/login",
          clstag: "DSGJ|85739",
        },
        {
          bannerUrl: require("@/assets/img/banner-two.png"),
          textUrl: require("@/assets/img/banner-text-two.png"),
          lookDetails: "查看详情",
          toUrl: "https://creator.jr.jd.com/#/login",
          clstag: "DSGJ|85740",
        },
        // {
        //   bannerUrl: require("@/assets/img/banner-three.png"),
        //   textUrl: require("@/assets/img/banner-text-one.png"),
        //   lookDetails: '查看详情',
        //   toUrl: 'https://creator.jr.jd.com/#/login'
        // },
      ],
    };
  },

  mounted() {},

  methods: {
    openNewWork(url) {
      if (url) window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-carousel {
  position: absolute;
  width: 100%;
  height: 1080px;
  margin: 0;
  ::v-deep .el-carousel__container {
    height: 1040px;
    .el-carousel__item {
      height: 1080px;

      .banner-swiper-div {
        position: relative;
        .banner-swiper-class {
          width: 100%;
          height: 1080px;
        }
        .banner-swiper-text {
          position: absolute;
          height: 320px;
          z-index: 1100;
          top: 350px;
          left: 245px;
          cursor: pointer;
        }
        .banner-swiper-lookDetails {
          
          position: absolute;
          width: 200px;
          height: 67px;
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 34px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 67px;
          text-align: center;
          top: 506px;
          left: 245px;
        }
        .banner-swiper-lookDetails-three {
          top: 573px;
        }
      }
    }
  }
  ::v-deep .el-carousel__indicators {
    bottom: 150px;

    .el-carousel__indicator {
      .el-carousel__button {
        width: 8px;
        height: 8px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(0, 0, 0, 0.3);
        border-radius: 50%;
      }
    }
    .is-active {
      .el-carousel__button {
        width: 50px;
        height: 8px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(0, 0, 0, 0.3);
        border-radius: 8px;
      }
    }
  }
}
::v-deep .el-carousel__arrow--left{
  width: 80px;
  height: 80px;
  background: url('@/assets/img/left.png') no-repeat;
  background-size: 100%;
  i{
    display: none;
  }
}
::v-deep .el-carousel__arrow--right{
  width: 80px;
  height: 80px;
  background: url('@/assets/img/right.png') no-repeat;
  background-size: 100%;
  i{
    display: none;
  }
}
</style>